import Script from 'next/script';
import * as React from 'react';

export function SetABNewRelicCustomAttribute({ cookieEnabled }: { cookieEnabled: boolean }) {
  if(!cookieEnabled) return null

  return <Script id="setABNewRelicCustomAttribute" strategy="beforeInteractive">
    {
      // language=JavaScript
      `
        function getCookieValue(name) {
          const cookies = document.cookie.split('; ');
          for (let cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=');
            if (cookieName === name) {
              return decodeURIComponent(cookieValue);
            }
          }
          return null;
        }

        try {
          if (typeof newrelic === 'object') {
            const cookie = getCookieValue('sunweb_ab');
            if (cookie) {
              newrelic.setCustomAttribute('sunweb_ab', cookie);
            }
          }
        } catch (e) {
          if (window.newrelic) {
            window.newrelic.noticeError(e);
          }
        }
      `
    }
  </Script>;
}


